import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Transformation3lzjezr9l4f8c as Transformation } from './Theme.mjs';
import { Companion_getInstance29xhjtuiwkkzk as Companion_getInstance } from './Easing.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.None_1 = new (ScreenTransitions())(Companion_getInstance_1().None_1, Companion_getInstance_1().None_1, Companion_getInstance_1().None_1);
        this.HorizontalSlide_1 = new (ScreenTransitions())(Companion_getInstance_1().Push_1, Companion_getInstance_1().Pop_1, Companion_getInstance_1().Fade_1);
        this.Fade_1 = new (ScreenTransitions())(Companion_getInstance_1().Fade_1, Companion_getInstance_1().Fade_1, Companion_getInstance_1().Fade_1);
        this.FadeResize_1 = new (ScreenTransitions())(Companion_getInstance_1().GrowFade_1, Companion_getInstance_1().ShrinkFade_1, Companion_getInstance_1().Fade_1);
        this.VerticalSlide_1 = new (ScreenTransitions())(Companion_getInstance_1().PullUp_1, Companion_getInstance_1().PullDown_1, Companion_getInstance_1().Fade_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ScreenTransitionsClass;
function ScreenTransitions() {
  if (ScreenTransitionsClass === VOID) {
    class $ {
      constructor(forward, reverse, neutral) {
        Companion_getInstance_0();
        this.forward_1 = forward;
        this.reverse_1 = reverse;
        this.neutral_1 = neutral;
      }
      toString() {
        return 'ScreenTransitions(forward=' + this.forward_1.toString() + ', reverse=' + this.reverse_1.toString() + ', neutral=' + this.neutral_1.toString() + ')';
      }
      hashCode() {
        var result = this.forward_1.hashCode();
        result = imul(result, 31) + this.reverse_1.hashCode() | 0;
        result = imul(result, 31) + this.neutral_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ScreenTransitions()))
          return false;
        if (!this.forward_1.equals(other.forward_1))
          return false;
        if (!this.reverse_1.equals(other.reverse_1))
          return false;
        if (!this.neutral_1.equals(other.neutral_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ScreenTransitions');
    ScreenTransitionsClass = $;
  }
  return ScreenTransitionsClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.None_1 = new (ScreenTransition())('None');
        this.Fade_1 = new (ScreenTransition())('Fade', VOID, VOID, true);
        this.Push_1 = new (ScreenTransition())('Push', new (Transformation())(1.0), new (Transformation())(-1.0));
        this.Pop_1 = new (ScreenTransition())('Pop', new (Transformation())(-1.0), new (Transformation())(1.0));
        this.FromLeft_1 = new (ScreenTransition())('FromLeft', new (Transformation())(-1.0), new (Transformation())(-1.0));
        this.FromRight_1 = new (ScreenTransition())('FromRight', new (Transformation())(1.0), new (Transformation())(1.0));
        this.PullUp_1 = new (ScreenTransition())('PullUp', new (Transformation())(VOID, 1.0), new (Transformation())(VOID, -1.0));
        this.PullDown_1 = new (ScreenTransition())('PullDown', new (Transformation())(VOID, -1.0), new (Transformation())(VOID, 1.0));
        this.GrowFade_1 = new (ScreenTransition())('GrowFade', new (Transformation())(VOID, VOID, VOID, VOID, VOID, VOID, 0.75, 0.75), new (Transformation())(VOID, VOID, VOID, VOID, VOID, VOID, 1.33, 1.33), true);
        this.ShrinkFade_1 = new (ScreenTransition())('ShrinkFade', new (Transformation())(VOID, VOID, VOID, VOID, VOID, VOID, 1.33, 1.33), new (Transformation())(VOID, VOID, VOID, VOID, VOID, VOID, 0.75, 0.75), true);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ScreenTransitionClass;
function ScreenTransition() {
  if (ScreenTransitionClass === VOID) {
    class $ {
      constructor(name, entryTransform, exitTransform, fade, easing) {
        Companion_getInstance_1();
        entryTransform = entryTransform === VOID ? new (Transformation())() : entryTransform;
        exitTransform = exitTransform === VOID ? new (Transformation())() : exitTransform;
        fade = fade === VOID ? false : fade;
        easing = easing === VOID ? Companion_getInstance().EaseInOut_1 : easing;
        this.name_1 = name;
        this.entryTransform_1 = entryTransform;
        this.exitTransform_1 = exitTransform;
        this.fade_1 = fade;
        this.easing_1 = easing;
      }
      toString() {
        return 'ScreenTransition(name=' + this.name_1 + ', entryTransform=' + this.entryTransform_1.toString() + ', exitTransform=' + this.exitTransform_1.toString() + ', fade=' + this.fade_1 + ', easing=' + this.easing_1.toString() + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + this.entryTransform_1.hashCode() | 0;
        result = imul(result, 31) + this.exitTransform_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.fade_1) | 0;
        result = imul(result, 31) + this.easing_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ScreenTransition()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!this.entryTransform_1.equals(other.entryTransform_1))
          return false;
        if (!this.exitTransform_1.equals(other.exitTransform_1))
          return false;
        if (!(this.fade_1 === other.fade_1))
          return false;
        if (!this.easing_1.equals(other.easing_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ScreenTransition');
    ScreenTransitionClass = $;
  }
  return ScreenTransitionClass;
}
//region block: exports
export {
  Companion_getInstance_1 as Companion_getInstance29ka8gqgdrya1,
  Companion_getInstance_0 as Companion_getInstance3htwskyquhuuo,
};
//endregion

//# sourceMappingURL=ScreenTransitions.mjs.map
